import React, { useState } from 'react'
import styles from './Select.module.scss'
import cl from 'classnames'
import { MenuItem, Select as MUSelect } from '@material-ui/core'
import { SelectProps } from './Select.types'
import { ChangeMarkPoint } from '../ChangeMarkPoint'

function SelectComponent<OptionType, CustomComponentProps = any> (
  props: SelectProps<OptionType, CustomComponentProps>
) {
  const {
    className,
    style,
    options,
    onChange,
    value,
    noneLabel = 'None',
    noNoneOption,
    placeholder,
    customOptionComponent: CustomOptionComponent,
    versionChange
  } = props

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange && onChange(event.target.value as OptionType)
  }

  const [isFocused, setIsFocused] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div className={styles.container}>
      <MUSelect
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        displayEmpty
        // label="Age"
        variant='outlined'
        className={cl(styles.rootClassName, {
          [styles.focused]: isHovered || isFocused,
          [styles.markedRed]: versionChange
        }, className)}
        style={{ ...style, height: '50px' }}
        classes={{
          root: styles.root,
          filled: styles.filled,
          outlined: styles.outlined,
          select: styles.select
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {!noNoneOption && (
          <MenuItem value=''>
            <em>{noneLabel}</em>
          </MenuItem>
        )}
        {options.map((option, index) =>
          <MenuItem
         
          key={index}
          value={option.value as unknown as any}
          >
            {CustomOptionComponent
              ? (
                <CustomOptionComponent
                  className={cl({
                    [styles.redColored]: versionChange
                  })}
                  {...option.customComponentProps}
                />
              )
              : option.label}
          </MenuItem>
        )}
      </MUSelect>
      {versionChange && (
        <ChangeMarkPoint
          {...versionChange}
        />
      )}
    </div>
  )
}

const Select = SelectComponent
export { Select }
